export default __webpack_public_path__ + "static/media/Vambraces of the Blood Drinker (nm).515f733f.jpg";